import React, { useState } from "react";
import { useHistory } from "react-router";

import { Form, Input, Button, Radio, InputNumber } from "antd";
import axios from "axios";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

function FormData() {
  //   const [formdata, setformdata] = useState(null);
  const [gender, setGender] = useState(0);

  let history = useHistory();

  const onFinish = (values) => {
    const bmi = (values.weight * 10000) / values.height ** 2;

    axios
      .post("https://healthinsafe.herokuapp.com/predict", {
        age: values.age,
        gender_num: gender,
        bmi: bmi,
        map: values.map,
        hr: values.hr,
        temp: values.temp,
      })
      .then((res) => {
        console.log(res);
        history.push({
          pathname: "/result",
          userData: { detail: res.data },
          bmi: bmi,
          usersName: values.Name,
        });
      })
      .catch((err) => console.log(err));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const genderhandle = (e) => {
    setGender(e.target.value);
  };

  return (
    <>
      <Form
        {...layout}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item label="Full Name" name="Name">
          <Input />
        </Form.Item>
        <Form.Item label="Age" name="age">
          <InputNumber />
        </Form.Item>

        <Radio.Group onChange={genderhandle} value={gender}>
          <Radio value={1}>Male</Radio>
          <Radio value={0}>Female</Radio>
        </Radio.Group>

        <Form.Item label="Height" name="height">
          <InputNumber />
        </Form.Item>

        <Form.Item label="Weigth" name="weight">
          <InputNumber />
        </Form.Item>

        <Form.Item label="heart rate" name="hr">
          <InputNumber />
        </Form.Item>

        <Form.Item label="temprature" name="temp">
          <InputNumber />
        </Form.Item>

        <Form.Item label="Blood Pressure" name="map">
          <InputNumber />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}

export default FormData;
